const inputCls =
  "w-full bg-white border border-[#122A1D]/15 focus:border-[#C8A24A] focus:outline-none text-[#122A1D] px-4 py-2.5 text-sm font-light transition-colors duration-300";

export const labelCls = "block text-xs uppercase tracking-[0.18em] text-[#5B6F64] mb-1.5";

const btnSmall =
  "text-xs uppercase tracking-wider border border-[#122A1D]/20 text-[#5B6F64] hover:border-[#C8A24A] hover:text-[#A9842F] px-3 py-1.5 transition-colors";

// Renders primitive field types only (no recursion)
function PrimitiveField({ def, value, onChange, testid }) {
  if (def.type === "text")
    return (
      <input
        data-testid={testid}
        className={inputCls}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );

  if (def.type === "textarea")
    return (
      <textarea
        data-testid={testid}
        rows={3}
        className={`${inputCls} resize-y`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );

  if (def.type === "tags")
    return (
      <input
        data-testid={testid}
        className={inputCls}
        value={(value || []).join(", ")}
        onChange={(e) =>
          onChange(
            e.target.value
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          )
        }
      />
    );

  if (def.type === "stringlist") {
    const items = value || [];
    return (
      <div className="space-y-2">
        {items.map((item, i) => (
          <div key={i} className="flex gap-2">
            <textarea
              data-testid={`${testid}-item-${i}`}
              rows={2}
              className={`${inputCls} resize-y`}
              value={item}
              onChange={(e) => onChange(items.map((it, j) => (j === i ? e.target.value : it)))}
            />
            <button
              type="button"
              className={btnSmall}
              onClick={() => onChange(items.filter((_, j) => j !== i))}
            >
              ✕
            </button>
          </div>
        ))}
        <button type="button" className={btnSmall} onClick={() => onChange([...items, ""])}>
          + Add
        </button>
      </div>
    );
  }

  return null;
}

// Renders any field type, including list (which uses PrimitiveField for sub-fields)
export function Field({ def, value, onChange, testid }) {
  if (def.type === "list") {
    const items = value || [];
    return (
      <div className="space-y-4">
        {items.map((item, i) => (
          <div key={i} className="border border-[#122A1D]/10 bg-[#F7F6F1] p-4 space-y-3">
            <div className="flex items-center justify-between">
              <p className="text-xs uppercase tracking-[0.18em] text-[#A9842F]">Item {i + 1}</p>
              {def.canAdd && (
                <button
                  type="button"
                  className={btnSmall}
                  onClick={() => onChange(items.filter((_, j) => j !== i))}
                >
                  Remove
                </button>
              )}
            </div>
            {def.fields.map((f) => (
              <div key={f.key}>
                <label className={labelCls}>{f.label}</label>
                <PrimitiveField
                  def={f}
                  testid={`${testid}-${i}-${f.key}`}
                  value={item?.[f.key]}
                  onChange={(v) =>
                    onChange(items.map((it, j) => (j === i ? { ...it, [f.key]: v } : it)))
                  }
                />
              </div>
            ))}
          </div>
        ))}
        {def.canAdd && (
          <button
            type="button"
            className={btnSmall}
            onClick={() => onChange([...items, { ...(def.newItem || {}) }])}
          >
            + Add item
          </button>
        )}
      </div>
    );
  }

  return (
    <PrimitiveField
      def={def}
      value={value}
      onChange={onChange}
      testid={testid}
    />
  );
}

export const SectionForm = ({ schema, data, onChange, sectionId }) => (
  <div className="space-y-5">
    {schema.map((def) => (
      <div key={def.key}>
        <label className={labelCls}>{def.label}</label>
        <Field
          def={def}
          testid={`field-${sectionId}-${def.key}`}
          value={data?.[def.key]}
          onChange={(v) => onChange({ ...data, [def.key]: v })}
        />
      </div>
    ))}
  </div>
);
